import './LinkGoBackLarge.css'
import * as React     from "react"
import {Translate}    from "react-localize-redux"
import {Link}         from "react-router-dom"

interface LinkGoBackProps{
  to ?: string
}
const LinkGoBack = (props:LinkGoBackProps) => {
  return (
    <Link className='LinkGoBackLarge' to={props.to?props.to:""}>
      <span className="GoBackTextLarge"><Translate id="common.goBack"/></span>
    </Link>
  )
}

export default LinkGoBack
